export default __webpack_public_path__ + "static/media/sizerpro-logo-white-v2.aa34cbef.svg";